import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";

export function TasteAppreciationModal({ open, compliment, loading, onContinue }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="taste-appreciation-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 bg-neutral-900 text-white flex items-center justify-center px-6"
        >
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.15, duration: 0.7, ease: [0.2, 0.7, 0.2, 1] }}
            className="max-w-2xl text-center"
          >
            <Sparkles className="mx-auto mb-8 opacity-70" size={28} />
            {loading ? (
              <p className="font-display text-3xl sm:text-4xl font-light italic opacity-70">Reading your taste…</p>
            ) : (
              <>
                <h2 data-testid="compliment-headline" className="font-display text-4xl sm:text-6xl font-light leading-[1.05]">
                  {compliment?.headline}
                </h2>
                <p data-testid="compliment-note" className="mt-8 text-base sm:text-lg text-neutral-300 leading-relaxed max-w-xl mx-auto">
                  {compliment?.note}
                </p>
                <button data-testid="appreciation-continue-button" onClick={onContinue} className="mt-12 inline-flex items-center justify-center rounded-full bg-white text-neutral-900 h-12 px-8 text-sm font-medium hover:bg-neutral-200 transition-colors">
                  Now, let's talk furniture
                </button>
              </>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
